import gql from 'graphql-tag'

export const blogTagsList = gql`
  {
    getBlogTagsByStore {
      name
      url_key
      id
    }
  }
`

export const blogSort = gql`
    query posts (
      $sort: String
      $direction: String
    ) {
    posts (
      sort: $sort,
      direction: $direction
    ) {
      items {
        post_id
        title
      }
    }
  }
`
